import { Button, Cascader, Divider, Form, Select } from 'antd'
import EditableInput from 'Components/Weaver/Input/EditableInput'
import { getInvertedNamespaces } from 'Services/WeaverUtils'
import UploadFileInput from './UploadFileInput'

const { Option } = Select

const getSelectedFunctionality = async (form, selectedFunctionality) => {
  const orchestrator = await Weaver.Plugin.load('weaver-orchestrator')
  const functionalityVersion = form.getFieldsValue().functionalityVersion
  const functionalities = JSON.parse(await orchestrator.getFunctionalities())
  const functionality = functionalities.find((f) => (f.name === selectedFunctionality && (f.version === functionalityVersion || true)))
  return functionality
}

const setConfigDefTypes = (form, selectedFunctionality) => {
  const properties = selectedFunctionality.configDefinition.properties
  const configDefTypesMap = {}
  for (const key in properties) {
    configDefTypesMap[key] = {
      type: properties[key].type,
      subType: properties[key].subType,
    }
  }

  form.setFieldsValue({
    configDefTypesMap
  })
}

const setVersion = (form, selectedFunctionality) => {
  form.setFieldsValue({
    functionalityVersion: selectedFunctionality.version
  })
}

export const FunctionalityFormItem = (({ cascaderData, form, taskId }) => {
    const toIgnore = ['name', 'functionalityName', 'functionalityVersion', 'branch']

    return (
      <>
        <Form.Item
          label="Functionality"
          name="functionalityName"
          rules={[
            {
              required: true,
              message: 'Select a functionality'
            }
          ]}
        >
          <Cascader
            data-testid="task-functionality-selector"
            dropdownClassName="functionalities-dropdown-items"
            showSearch={true}
            allowClear={true}
            options={cascaderData}
            onChange={async (value) => {
              const fieldKeys = Object.keys(form.getFieldsValue(true))
              const fieldsToReset = fieldKeys.filter((field) => !toIgnore.includes(field))
              form.resetFields(fieldsToReset)
              const functionality = await getSelectedFunctionality(form, value.join("."))
              setConfigDefTypes(form, functionality)
              setVersion(form, functionality)
            }}
            style={{ width: '100%' }}
            disabled={taskId !== 'new'}
          />
        </Form.Item>
        <Form.Item
          style={{ display: "none" }}
          name="configDefTypesMap"
        />
      </>
    )
  })

export const VersionFormItem = ({ taskId, versionData, form }) => {

  const onChange = () => {
    const { functionalityName } = form.getFieldsValue()
    const functionality = getSelectedFunctionality(form, functionalityName)
    setConfigDefTypes(form, functionality)
    setVersion(form, functionality)
  }

  return (
    <Form.Item
      label="Version"
      name="functionalityVersion"
      rules={[
        {
          required: true,
          message: 'Input functionality version'
        }
      ]}
    >
      <Select
        disabled={taskId !== 'new'}
        onChange={onChange}
      >
        {
          versionData?.map((version) =>
            <Option
              key={`task-version-${version}`}
              value={version}
            >
              { version }
            </Option>
          )
        }
      </Select>
    </Form.Item>
  )
}

export const BranchFormItem = ({ branches, taskId }) => {
  return (
    <Form.Item
      label="Branch"
      name="branch"
    >
      <Select
        data-testid="task-target-branch-selector"
        disabled={taskId !== 'new'}
      >
      {
        branches?.map((branch) =>
          <Option
            key={`task-targetBranch-${branch.id()}`}
            value={branch.id()}
          >
            { branch.name() }
          </Option>
        )
      }
      </Select>
    </Form.Item>
  )
}

const getFormItems = (data) => {
  if (_.isEmpty(data)) {
    return []
  } else {
    return _.reduce(data.configDefinition.properties, (acc, val, key) => {
      val.required = data.configDefinition.required?.includes(key) || false
      acc[key] = val
      return acc
    }
    , {})
  }
}

const FormInput = ({ form, required, type, subType, label, field }) => {
  const CopyPrefixes = () => (
    <div style={{ width: '100%', display: 'flex', justifyContent: 'center'}}>
      <Button
        type="link"
        onClick={() => {
          form.setFieldsValue({
            config: {
              prefixes: JSON.stringify(getInvertedNamespaces(), null, 2)
            }
          })
      }}>
        Copy Prefixes
      </Button>
    </div>
  )

  const inputProps = {
    name: field,
    "data-testid": `task-form-item-${field}`,
    field: field,
    form: form,
    type: type,
    subType: subType,
    extra: label === 'prefixes' ? <CopyPrefixes /> : null
  }

  return (
    <Form.Item
      label={_.startCase(label)}
      name={field}
      rules={[{ required: required }]}
      valuePropName={Weaver.Attribute.typesBoolean.includes(type) ? 'checked' : 'value'}
    >
      {
        [ 'fileUid', 'fileId', 'wvr:fileId' ].includes(type)
        ?
          <UploadFileInput {...inputProps} />
        :
          <EditableInput {...inputProps} />
      }
    </Form.Item>
  )
}

export const ConfigFormItems = ({ form, functionality }) => {
  if (functionality !== undefined) {
    return (
      <div data-testid="create-task-config-section">
        <Divider>Config</Divider>
        <Form.Item name="config">
        {
          _.map(getFormItems(functionality), ({ description, required, type, subType }, key) =>
            <FormInput
              form={form}
              key={key}
              label={key}
              field={["config", key]}
              type={type}
              subType={subType}
              description={description}
              required={required}
            />
          )
        }
        </Form.Item>
      </div>
    )
  } else {
    return null
  }
}
